import { push as routerPush } from 'redux-first-history';

import { fetchConfig } from 'common/actions/config';
import { OVERVIEW_DASHBOARD_PATH } from 'common/selectors/sidebar/affiliates';
import { registrationSuccessAction } from 'users/reducers/registration';

/**
 * Auth middleware function
 */
const middleware = (store) => (next) => (action) => {
  const { dispatch } = store;

  const result = next(action);

  switch (action.type) {
    case registrationSuccessAction.type: {
      dispatch(fetchConfig()).then(() =>
        dispatch(routerPush(OVERVIEW_DASHBOARD_PATH)),
      );

      break;
    }

    default:
      break;
  }

  return result;
};

export default middleware;
